export const LANGS_EN = {
  en: 'English',
  ru: 'Russian',
};
